module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_6.db80ae3b.png";